import { XYPosition } from '../../types/xy-position';
import { Guid } from '../guid';

export const FLOW_NOTE_LIMITS = {
	MAX_CHARS: 500,
	MAX_NOTES_PER_FLOW: 10,
} as const;

export class FlowNoteConfig {
	id = Guid();
	note = '';
	nodePosition: XYPosition = { x: 0, y: 0 };
	width = 200;
	height = 120;
}
